import { createAsyncThunk } from '@reduxjs/toolkit';
import { billingProcessService, itemService, registerService, userService } from 'services';
import { ItemResponse, t_cpap_instructions } from 'types';

export const updateCPAP = createAsyncThunk<
  ItemResponse,
  { workSpaceId?: string; item: t_cpap_instructions; statusBill: boolean }
>('items/updateItem', async (params) => {
  const related_ds_items: any = {
    t_hospital_visit: [],
  };
  if (params.workSpaceId) {
    const { data: listApp } = await userService.getListApplicationsByWorkspaceId(params.workSpaceId);
    const cpapApp = listApp ? listApp.find((f: any) => f.display_id === 'CPAP') : null;
    const hospitalDb = cpapApp ? cpapApp.datastores.find((f: any) => f.display_id === 't_hospital_visit') : null;
    if (hospitalDb) {
      const linkHospital = params.item.item_links?.links.find((f) => f.d_id === hospitalDb.datastore_id);
      if (linkHospital) {
        const today = new Date();
        const listDelete: any = [];
        const preTargetMonth =
          today.getMonth() === 0
            ? `${today.getFullYear() - 1}12`
            : `${today.getFullYear()}${('0' + today.getMonth()).slice(-2)}`;
        const { data: listHost } = await billingProcessService.searchHospital({
          per_page: 0,
          page: 1,
          conditions: [
            {
              search_value: linkHospital.items.map((item) => item.i_id),
              id: 'i_id',
              include_null: false,
              exact_match: true,
            },
          ],
          include_lookups: false,
        });
        listHost.items.map((item: any) => {
          if (String(item.target_month) === preTargetMonth && item.Status !== '請求済み' && !params.statusBill) {
            listDelete.push({
              operation: 3,
              action_id: '',
              i_id: item.i_id,
            });
          }
          return null;
        });

        related_ds_items.t_hospital_visit = listDelete;
      }
    }
  }
  const { data } = await itemService.updateItem(params.item, related_ds_items);
  let action = '';
  if (params.item.suspension_flg && params.item.suspension_flg.toString() === '1') {
    action = 'a_move_to_suspension';
  } else {
    action = 'a_move_to_use';
  }
  const conditions = [
    {
      id: 'cpap_id',
      search_value: [params.item.i_id],
    },
  ];
  const candidate = await registerService.searchCandidate({ conditions: conditions });
  if (candidate.data.totalItems > 0) {
    await registerService.excecuteCPAP({
      item_id: candidate.data.items[0].i_id,
      action: action,
    });
  }

  return data;
});
